// src/components/backend/companies/sections/SectionStammdaten.jsx
import React from "react";
import { Box, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const DEFAULT_SALUTATIONS = [
    "Frau",
    "Herr",
    "Firma",
    "Direktion Geschäftsführung",
    "Familie",
    "Herr und Frau",
    "Frau und Herr",
    "Gastgeber",
    "Gastgeberin",
];

export default function SectionStammdaten({ form, setForm, salutations = DEFAULT_SALUTATIONS }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "1fr 1fr 1fr 1fr",
                },
                gap: 2,
            }}
        >
            <TextField
                label="Firmenname*"
                value={form.name || ""}
                onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                fullWidth
            />

            <TextField
                label="URL-Slug"
                value={form.slug || ""}
                InputProps={{ readOnly: true }}
                helperText="Wird automatisch aus dem Firmennamen erzeugt."
                fullWidth
            />

            <TextField
                label="Kundennummer"
                value={form.customer_number || ""}
                onChange={(e) => setForm((f) => ({ ...f, customer_number: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Vertragsdatum"
                type="date"
                value={(form.contract_date || "").substring(0, 10)}
                onChange={(e) => setForm((f) => ({ ...f, contract_date: e.target.value }))}
                InputLabelProps={{ shrink: true }}
                fullWidth
            />

            <FormControl fullWidth>
                <InputLabel>Anrede</InputLabel>
                <Select
                    label="Anrede"
                    value={form.salutation || ""}
                    onChange={(e) => setForm((f) => ({ ...f, salutation: e.target.value }))}
                >
                    <MenuItem value="">
                        <em>-</em>
                    </MenuItem>
                    {salutations.map((s) => (
                        <MenuItem key={s} value={s}>
                            {s}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <TextField
                label="Bezeichnung / Name des Betriebes"
                value={form.business_name || ""}
                onChange={(e) => setForm((f) => ({ ...f, business_name: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Vorname + Name (Kontakt)"
                value={form.contact_full_name || ""}
                onChange={(e) => setForm((f) => ({ ...f, contact_full_name: e.target.value }))}
                fullWidth
            />
        </Box>
    );
}
